import React from 'react';
export const VoiceRecordingTimer = ({ isRunning }) => {
    const [recordingStartTime, setRecordingStartTime] = React.useState(null);
    const [recordingEndTime, setRecordingEndTime] = React.useState(null);
    const [recordingTime, setRecordingTime] = React.useState(0);
    React.useEffect(() => {
        if (isRunning) {
            startTimer();
        }
        else {
            stopTimer();
        }
        return () => {
            stopTimer();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRunning]);
    const startTimer = () => {
        setRecordingStartTime(new Date());
        setRecordingEndTime(null);
        runTimer();
    };
    const stopTimer = () => {
        setRecordingTime(0);
        setRecordingEndTime(new Date());
    };
    React.useEffect(() => {
        if (isRunning) {
            runTimer();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordingTime]);
    const runTimer = () => {
        setTimeout(() => {
            if (isRunning) {
                setRecordingTime(recordingTime + 1);
            }
        }, 1000);
    };
    const getRecordingTime = () => {
        if (!recordingStartTime) {
            return '00:00';
        }
        const endTime = recordingEndTime || new Date();
        const recordingDuration = endTime.getTime() - recordingStartTime.getTime();
        const startPos = recordingDuration >= 3600 * 1000 ? 11 : 14;
        const len = recordingDuration >= 3600 * 1000 ? 8 : 5;
        return new Date(recordingDuration).toISOString().substr(startPos, len);
    };
    return React.createElement("span", { "data-testid": 'recording-timer' }, getRecordingTime());
};
